<template>
    <div class="img_detail" v-wechat-title="$route.meta.title">
        <div class="head">
            <div class="title">
                {{detail.description}}
            </div>
            <div class="con">
                <span>@{{detail.CategoryName}}</span>
                <div class="time_wrap">
                    <p>{{Total}}张图片</p>
                    <span>{{detail.createtime | momentFormat('YYYY/MM/DD')}}</span>
                </div>
            </div>
        </div>

        <div class="list">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">

                <waterfall :col='col' :data="list" :width="itemWidth" :gutterWidth="gutterWidth">
                    <template >
                        <div 
                            class="cell-item" 
                            v-for="(item,index) in list" 
                            :key="index">

                            <img 
                                v-lazy="item.url" 
                                alt="" 
                                @click="getImg(index)">

                        </div>
                    </template>
                </waterfall>
                
            </van-list>
        </div>
        <wxsdk v-if="isWxSdk" :isHidden="true" :config="wxconfig"></wxsdk>
    </div>
</template>

<script>
import $ from 'jquery'
import { Toast } from 'vant';
import { ImagePreview } from 'vant';

export default {
    name: 'imgDetail',
    data(){
        return {
            col: 2,
            list: [],
            loading: false,
            finished: false,
            Total: 0,
            page: 0,
            detail: {},
            wxconfig:{
                title: '业之峰环保装饰', // 分享标题
                link: window.location.href.split('#')[0], // 分享链接
                desc: '诺云出品，营销神器', // 分享描述
                imgUrl: 'https://yenova-picfw.oss-cn-qingdao.aliyuncs.com/shadow/20200215084744', // 分享图标
            },
            isWxSdk: true,
        }
    },
    computed:{
        itemWidth(){  
            return (345*0.5*(document.documentElement.clientWidth/375))  //#rem布局 计算宽度
        },
        gutterWidth(){
            return (10*0.5*(document.documentElement.clientWidth/375))   //#rem布局 计算x轴方向margin(y轴方向的margin自定义在css中即可)
        }
    },
    components: {
        wxsdk: () => import('@/components/Wxsdk'),
    },
    created(){
        
    },
    mounted(){
        this.getDetail()
    },
    methods:{
        //点击预览大图，index是点击的图片index，listIndex是信息的index
        getImg(index){
            let that = this

            // 为url添加参数
            var lookUrl = window.location.href + '&look';
            window.history.pushState(null, null, lookUrl);
            // 重启jsdk
            that.isWxSdk = false;
            that.$nextTick(()=>{
                that.isWxSdk = true;
            })
            
            // console.log(index)
            // console.log(this.list)
            // 开启大图预览
            let imgLibraryImagePreview = new ImagePreview({
                images: this.list.map(e=>{
                    return e.url
                }),
                startPosition: index,
                showIndicators: true,
                lazyLoad: true,
                onClose: (e)=>{
                    // console.log(e)
                    // 清除url的参数
                    if (window.location.href.indexOf('&look') !== -1) {
                        window.history.back();
                    }
                    // console.log('关闭图片预览模式')
                    
                }
            });

            if (window.history && window.history.pushState) {
                //监听浏览器前进后退事件
                $(window).on('popstate', function () {
                    //do something...
                    // console.log(imgLibraryImagePreview)
                    // 关闭大图预览
                    imgLibraryImagePreview.close()
                });
            }

        },
        getDetail(){
            // console.log(this.$route.query.id)
            var data = {
                id: this.$route.query.id	//是	long	图片库id
            }
            this.$get("/api/PictureDepot/Details",data).then((res)=>{
                if (res.Success) {
                    // console.log(res.Object)
                    this.detail = res.Object
                }else{
                    Toast.success({
                        
                        message: res.Message
                    });
                }
            })
        },
        //获取列表
        getData(){
            var params = {
                parentid: this.$route.query.id, 	//是	long	图片库id
                page: this.page	//否	int	页码 （默认1）
            };
            return new Promise((resolve, reject)=>{
                this.$get("/api/Picture/Get", params).then(res => {
                    if (res.Success) {
                        var arr = res.Object.Data;
                        // 瀑布流的尺寸计算有问题，必须遍历
                        // this.list = [...this.list, ...res.Object.Data]
                        
                        arr.forEach(e => {
                            this.list.push(e)
                        });

                        this.Total = res.Object.Total;
                        // console.log(this.total)
                        // console.log(res.Object.Data)
                        resolve()
                    }
                }).catch(res => {
                    // console.log(res)
                    this.error = true;
                    reject()
                });
            })
        },
        //滚动加载更多数据
        onLoad() {
            this.page += 1;
            // 异步更新数据
            this.getData().then(()=>{
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                if (this.list.length >= this.Total) {
                    this.finished = true;
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.img_detail{
    width: 100vw;
    .head{
        padding: 30px 25px;
        display: flex;
        flex-direction: column;
        .title{
            font-size: 37px;
            line-height: 57px;
            color: #333333;
            margin-bottom: 40px;
        }
        .con{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-size: 25px;
            color: #999999;
            .time_wrap{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                p{
                    margin-right: 20px;
                }
            }

        }
    }

    .list{
        width: 100vw;
        display: flex;
        justify-content: center;
        .vue-waterfall{
            overflow-y: hidden;
        }
        .cell-item{
            img{
                width: 100%;
                margin-bottom: 9px;
            }
        }

    }
}
</style>